<section class="about pageHeight" id="about">
  <h2 class="section-title m-0" [innerHTML]="'about.title' | translate"></h2>
  <h3 class="section-desc fw-normal" [innerHTML]="'about.desc' | translate"></h3>

  <!---- Desktop -->
  <div class="d-flex main-wrapper" *ngIf="!isMobile">
    <div class="box">
      <img src="/assets/images/png/about1.png" alt="about-img" class="img-fluid about-img" loading="lazy" />
      <p class="width h3-item">{{ 'about.head1' | translate }}</p>
      <p class="para">{{ 'about.para1' | translate }}</p>
    </div>
    <img src="/assets/images/png/about-arrow.png" alt="about-img" class="img-fluid arrow" loading="lazy" />
    <div class="box">
      <img src="/assets/images/png/about2.png" alt="about-img" class="img-fluid about-img" loading="lazy" />
      <p class="h3-item">{{ 'about.head2' | translate }}</p>
      <p class="para">{{ 'about.para2' | translate }}</p>
    </div>
    <img src="/assets/images/png/about-arrow.png" alt="about-img" class="img-fluid arrow" loading="lazy" />
    <div class="box">
      <img src="/assets/images/png/about3.png" alt="about-img" class="img-fluid about-img" loading="lazy" />
      <p class="h3-item">{{ 'about.head3' | translate }}</p>
      <p class="para">{{ 'about.para3' | translate }}</p>
    </div>
  </div>

  <!----Mobile-->

  <div class="wrapper-mobile position-relative" *ngIf="isMobile">
    <div class="mobile-slider d-flex overflow-auto" #slider>
      <div class="box">
        <img src="/assets/images/png/about1.png" alt="about-img" class="img-fluid about-img" loading="lazy" />
        <p class="width h3-item">{{ 'about.head1' | translate }}</p>
        <p class="para">{{ 'about.para1' | translate }}</p>
      </div>
      <img src="/assets/images/png/about-arrow.png" alt="about-img" class="img-fluid arrow" loading="lazy" />
      <div class="box">
        <img src="/assets/images/png/about2.png" alt="about-img" class="img-fluid about-img" loading="lazy" />
        <p class="h3-item">{{ 'about.head2' | translate }}</p>
        <p class="para">{{ 'about.para2' | translate }}</p>
      </div>
      <img src="/assets/images/png/about-arrow.png" alt="about-img" class="img-fluid arrow" loading="lazy" />
      <div class="box">
        <img src="/assets/images/png/about3.png" alt="about-img" class="img-fluid about-img" loading="lazy" />
        <p class="h3-item">{{ 'about.head3' | translate }}</p>
        <p class="para">{{ 'about.para3' | translate }}</p>
      </div>
    </div>
  </div>
  <div class="video-wrap d-block d-sm-none">
    <video class="video" width="100%" #videoPlayer autoplay muted playsInline loop>
      <source src="/assets/images/videos/how-to-buy.mp4" type="video/mp4">
      Your browser does not support the video tag
    </video>
  </div>
  <div class="drop-shadow d-lg-inline-block d-none">
    <a routerLink="/{{ currentLanguage }}" fragment="how-to-buy" (click)="navigateToPage('how-to-buy')"
      class="btn btn-primary animation py-3 font-20 fw-semibold">{{ 'misc.hot_to_buy_cta' | translate }}</a>
  </div>
</section>